import { useParams } from 'react-router-dom'
import { useGetLabDeviceQuery } from 'store/services/devices'
import { skipToken } from '@reduxjs/toolkit/query/react'
import moment from 'moment'
import Link from '../../atoms/Link'
import routes from '../constants/routes'
import DeviceHistory from './DeviceHistory'

const PatientsList = () => {
    const { id } = useParams()
    const { data: device, isLoading } = useGetLabDeviceQuery(id ? Number(id) : skipToken)

    if (isLoading) {
        return <div className="text-center text-muted">Loading device information...</div>
    }

    if (!device) {
        return <div className="text-center text-muted">No device data available</div>
    }

    return (
        <div className="row">
            <div className="col-12 mb-4">
                <h5 className="card-title mb-3">Current Patient</h5>
                <div className="table-responsive">
                    <table className="table table-sm table-bordered">
                        <thead className="thead-light">
                            <tr>
                                <th>Order ID</th>
                                <th>Patient Name</th>
                                <th>DOB</th>
                                <th>Assigned At</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {device.currentOrder ? (
                                <tr>
                                    <td>
                                        <span className="badge badge-primary" style={{fontSize: '14px', lineHeight: '16px'}}>
                                            #{device.orderId}
                                        </span>
                                    </td>
                                    <td>
                                        {device.currentOrder.patientName || 'Unknown Patient'}
                                    </td>
                                    <td>
                                        {device.currentOrder.patientDob 
                                            ? moment(device.currentOrder.patientDob).format('MM/DD/YYYY')
                                            : '-'
                                        }
                                    </td>
                                    <td>
                                        {device.currentOrder.deviceAssignedAt 
                                            ? moment(device.currentOrder.deviceAssignedAt).format('MM/DD/YYYY')
                                            : '-'
                                        }
                                    </td>
                                    <td>
                                        <Link
                                            to={`${routes.index}${routes.order.edit}${device.orderId}`}
                                            className="btn btn-sm btn-outline-primary"
                                            label="View Order"
                                            icon="fa fa-eye"
                                        />
                                    </td>
                                </tr>
                            ) : (
                                <tr>
                                    <td colSpan={5} className="text-center text-muted">
                                        No current patient assigned
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

            <div className="col-12">
                <h5 className="card-title mb-3">Previous Patient</h5>
                <div className="table-responsive">
                    <table className="table table-sm table-bordered">
                        <thead className="thead-light">
                            <tr>
                                <th>Order ID</th>
                                <th>Patient Name</th>
                                <th>DOB</th>
                                <th>Assigned At</th>
                            </tr>
                        </thead>
                        <tbody>
                            {device.previousOrder ? (
                                <tr>
                                    <td>
                                        <span className="badge badge-secondary" style={{fontSize: '14px', lineHeight: '16px'}}>
                                            #{device.previousOrderId}
                                        </span>
                                    </td>
                                    <td>{device.previousOrder.patientName || 'Unknown Patient'}</td>
                                    <td>
                                        {device.previousOrder.patientDob
                                            ? moment(device.previousOrder.patientDob).format('MM/DD/YYYY')
                                            : '-'
                                        }
                                    </td>
                                    <td>
                                        {device.previousOrder.deviceAssignedAt 
                                            ? moment(device.previousOrder.deviceAssignedAt).format('MM/DD/YYYY')
                                            : '-'
                                        }
                                    </td>
                                </tr>
                            ) : (
                                <tr>
                                    <td colSpan={4} className="text-center text-muted">
                                        No previous patients found
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

            <DeviceHistory />
        </div>
    );
}

export default PatientsList;